<template>
  <div id="Agents">
    <v-container grid-list-xl fluid>
      
        <v-layout row wrap>
          <v-flex md12 sm12 class="my-4">
              <h3>CAJERO GN / LISTADO</h3>
          </v-flex>
          <v-flex xs12 md6 lg6>
            <v-text-field label="Buscar por ATM..." v-model="name"></v-text-field>
          </v-flex>
          <v-flex xs12 md6 lg6>
            <v-text-field label="Buscar por ID ATM..." v-model="identificador"></v-text-field>
          </v-flex>
          <!--<v-flex xs12 md4 lg4>
            <v-text-field label="Buscar por N Serie..." v-model="serie"></v-text-field>
          </v-flex>-->
         <!-- <v-flex xs12 md6 lg6>
            <v-select
              :items="types"
              label="Filtrar Tipo"
              item-text="text"
              item-value="value"
              v-model="type"
            ></v-select>
          </v-flex>-->


          <v-flex xs12 md4 lg4>
            <v-select
            @change="getProvincias()"
            single-line
            hide-details
            return-object
              menu-props="auto"
              :items="selectDepartaments"
              label="Filtrar Departamento"
              item-text="nombre"
              v-model="departamentFilter"
            ></v-select>
          </v-flex> 

          <v-flex xs12 md4 lg4>
            <v-select
            @change="getDistritos()"
            single-line
            hide-details
            return-object
            menu-props="auto"
              :items="selectProvincias"
              label="Filtrar Provincia"
              item-text="nombre"
              v-model="provinciasFilter"
            ></v-select>
          </v-flex> 
           
          <v-flex xs12 md4 lg4>
            <v-select
            single-line
            hide-details
            return-object
            menu-props="auto"
              :items="selectDistrict"
              label="Filtrar Distrito"
              item-text="nombre"
              v-model="districtFilter"
            ></v-select>
          </v-flex> 

          
          <v-btn color="success" @click="getList()">Buscar</v-btn>
          <download-excel :data="json_data" :fields="json_fields">
            <v-btn color="blue-grey" class="white--text" :disabled="loaderExcel">
              <v-icon right dark>assignment_returned</v-icon>Descargar Excel
            </v-btn>
          </download-excel>
        </v-layout>
        <v-divider></v-divider>
        <v-progress-circular
          indeterminate
          :size="40"
          v-if="generalLoader == true"
          style="position: fixed; bottom: 10%; right: 5%;"
          color="primary"
        ></v-progress-circular>

        <v-data-table
          hide-actions
          :headers="complex.headers"
          :items="complex.items"
          item-key="name"
        >
          <template slot="items" slot-scope="props">
            <td>
              
              <v-tooltip bottom color="info">
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="info"
                    v-on="on"
                    @click="viewDetail( props.item.agents )"
                    :disabled="loader.saveBtn"
                  >
                    {{ props.item.agents }}
                  </v-btn>
                </template>
                 <span>Ver información del agente</span>
              </v-tooltip>
             </td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.direction | truncate(10, '...') }}</td>
            <td>{{ props.item.department }}</td>
            <td>{{ props.item.province }}</td>
            <td>{{ props.item.district }}</td>
            <td style="max-width: 225px; min-width: 225px">
              <v-tooltip bottom color="info">
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="info"
                    v-on="on"
                    @click="editar( props.item.id )"
                    :disabled="loader.saveBtn"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom color="error">
                <template v-slot:activator="{ on }">
                  <v-btn
                    flat
                    icon
                    color="error"
                    v-on="on"
                    @click="eliminar( props.item.id )"
                    :disabled="loader.saveBtn"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>


              </td>
          </template>
        </v-data-table>

        <v-card flat>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-pagination
            circle
            v-model="pagination.page"
            :length="pagination.page_count"
            @input="getList()"
            @next="getList()"
            @previous="getList()"
          ></v-pagination>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    </v-container>

    <v-snackbar :timeout="3000" top right :color="snackbar.color" v-model="snackbar.show">
      <p style="margin: 0">
        <i :class="snackbar.icon"></i>
        &nbsp;
        {{ snackbar.text }}
      </p>
      <v-btn dark flat @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-icon></v-icon>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "@/api/axios/config";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  data() {
    return {
      search: "",
      isEdit: false,
      id: null,
      pagination: {
        page_count: null,
        page: 1,
        act_page: 0
      },
      itemsPerPage: 50,
      //pageCount: 0,
      name: "",
      value: "",
      type: "",
      departamentFilter:"",
      selectDepartaments:[],
      provinciasFilter:"",
      selectProvincias:[],
      districtFilter:"",
      selectDistrict:[],
      statusDocumentFilter:"",
      statusfilterSelect: "",
      identificador: "",
      serie: "",
      description: "",
      loader: false,
      saveBtn: false,
      rules: {
        required: value => !!value || "Campo requerido."
      },
      appEvents: [],
      complex: {
        headers: [
          {
            text: "ATM",
            value: "agent_id"
          },
          {
            text: "Nombre",
            value: ""
          },
          {
            text: "Dirección",
            value: ""
          },
          {
            text: "Departamento",
            value: ""
          },
          {
            text: "Provincia",
            value: ""
          },
          {
            text: "Distrito",
            value: ""
          },
           
          {
            text: "Operaciones",
            value: ""
          }
        ],
        items: []
      },
      types: [
        { value: "DECLARACION JURADA", text: "Declaración jurada" },
        { value: "LICENCIA", text: "Licencia" },
        { value: "AUTORIZACIÓN DE ANUNCIO", text: "Autorización de Anuncio" },
        { value: "NORMA LEGAL", text: "Norma Legal" }
      ],
      status: [
        { value: "PENDIENTE", text: "Pendiente" },
        { value: "EN CURSO", text: "En curso" },
        { value: "COMPLETADO", text: "Completado" },
        { value: "RECHAZADO", text: "Rechazado" }
      ],
      statusfilter: [
        { value: "PENDIENTE", text: "Pendiente" },
        { value: "EN CURSO", text: "En curso" },
        { value: "VENCIDAD", text: "Solicitud Vencidad" }
      ],
      selectDocument:[
        {value: "Completado", text: "Completado"},
        {value: "Sin Información", text: "Sin Información"},
      ],
      snackbar: {
        show: false,
        text: "",
        color: "",
        icon: ""
      },
      basic: {
        dialog: false
      },
      dialog: false,
      saveLoader: false,
      removeLoader: false,
      generalLoader: false,
      modalLoader: false,
      disabled: false,
      loaderExcel: false,
      form: {
        agent_id: "",
        num: "",
        serie: "",
        sign_type: "",
        type: "",
        date: "",
        attachment: "",
        exp_date: "",
        status: "",
        observations: "",
        agents: []
      },
      json_fields: {
        "Agente": "agents",
        "Nombre": "name",
        "Dirección": "direction",
        "Distrito": "district",
        "Provincia": "province",
        "Departamento": "department",
      
      },
      json_data: []
    };
  },
  filters: {
    formatDate: function(date) {
      if (date != null && date != "") {
        return moment(date).format("DD-MM-YYYY");
      }
    },
    truncate: function(text, length, suffix) {
      return text.substring(0, length) + suffix;
    }
  },
  mounted() {
    this.getList();
    this.getListExcel();
    this.getDepartamentos();
  },
  methods: {
    getList() {
      this.generalLoader = true;


      axios({
         method: "GET",
        url: "gn/cajero-gn/listado",
        params: {
          name:this.name,
          identificador:this.identificador,
          type:this.type,
          status:this.status,
          serie:this.serie,
          departamentFilter:this.departamentFilter.nombre ? this.departamentFilter.nombre : '',
          provinciasFilter:this.provinciasFilter.nombre ? this.provinciasFilter.nombre : '',
          districtFilter:this.districtFilter.nombre ? this.districtFilter.nombre : '',
          statusDocumentFilter:this.statusDocumentFilter,
          page:this.pagination.page,
          limit:this.itemsPerPage
        },
      }).then(response => {
          this.complex.items = response.data.items;
          this.pagination.page_count = response.data.total;
          this.pagination.page = Number(response.data.page);
          this.pagination.act_page = Number(response.data.page);
          this.generalLoader = false;

        })
        .catch(error => {
          console.log(error);
        });



    },


     eliminar(id) {
      this.$confirm("¿Realmente quieres eliminar este elemento?").then(res => {
        if (res) {
          this.listLoading = true;
          axios
            .delete("gn/cajero-gn/eliminar/" + id)
            .then(response => {
              if (response.data.status) {
                this.snackbar = {
                  icon: "check_circle",
                  text: "¡Elemento eliminado!",
                  color: "success",
                  show: true
                };
              } else {
                this.snackbar = {
                  icon: "error",
                  text: "Ocurrió un error en el servidor...",
                  color: "error",
                  show: true
                };
              }
            })
            .catch(error => {
              this.snackbar = {
                icon: "error",
                text: error,
                color: "error",
                show: true
              };
            })
            .finally(() => {
              this.listLoading = false;
              this.getList(this.pagination.act_page);
            });
        }
      });
    },


    getDepartamentos() {
      axios
        .get(
          "gn/agents-listDepartamentos"
        )
        .then(response => {
           this.selectDepartaments = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getProvincias(){
      this.selectDistrict = [];
      axios
        .get(
          "gn/agents-listProvincias?iddepartamento="+this.departamentFilter.iddepartamento
        )
        .then(response => {
           this.selectProvincias = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });

    },

    getDistritos(){
      axios
        .get(
          "gn/agents-listDistritos?idprovincia="+this.provinciasFilter.idprovincia
        )
        .then(response => {
           this.selectDistrict = response.data.data;
        })
        .catch(error => {
          console.log(error);
        });

    },


    getListExcel() {
      this.loaderExcel = true;
      axios
        .get(
          "gn/cajero-gn/listado?" +
            "name=" +
            this.name +
            "&page=" +
            this.pagination.page +
            "&limit="+this.itemsPerPage
        )
        .then(response => {
          this.json_data = response.data.items;
          this.loaderExcel = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    clearInputs() {
      this.name = "";
      this.value = "";
      this.description = "";
    },
    
    viewDetail(id) {
      this.$router.push("/GN/data-gn/agents/agents-detail-gn/" + id);
    },

    editar(id) {
      this.$router.push("/GN/cajero-gn/modificar/" + id);
    }
  }
};
</script>

<style>

.texto-rojo{
  color: red;
  font-weight: bold;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>